import { render, staticRenderFns } from "./CopyOptionsSlot.vue?vue&type=template&id=f000d52e&scoped=true&"
import script from "./CopyOptionsSlot.vue?vue&type=script&lang=js&"
export * from "./CopyOptionsSlot.vue?vue&type=script&lang=js&"
import style0 from "./CopyOptionsSlot.vue?vue&type=style&index=0&id=f000d52e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f000d52e",
  null
  
)

export default component.exports